import React from 'react';
import {
    Box,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    ListItem,
    ListItemIcon,
    ListItemText,
    Select,
    Typography,
} from '@mui/material';
import { Check, Delete, Error, Person, Schedule } from '@mui/icons-material';
import bytesToHumanReadable from 'lib/bytesToHumanReadable';

const UploadFormFileRow = ({ index, file, handleRemoveFile, handleChangeQuality, loading }) => {
    const isHeicOrHeif = /\.(heic|heif)$/i.test(file.name);
    const showConversionWarning = isHeicOrHeif && file.quality === 'original';

    return (
        <ListItem sx={{ alignItems: 'flex-start' }}>
            <ListItemIcon>
                <Person />
            </ListItemIcon>

            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <ListItemText primary={file.name} secondary={bytesToHumanReadable(file.size)} />

                {showConversionWarning && (
                    <Typography variant="caption" color="warning.main" display="block" sx={{ mt: 0.5 }}>
                        This file will be converted to JPEG format to ensure maximum compatibility.
                    </Typography>
                )}
            </Box>

            <Box sx={{ ml: 2, flexShrink: 0 }}>
                <Grid container spacing={2}>
                    {file.status === 'NONE' && (
                        <>
                            <Grid size={{ xs: 8 }}>
                                <FormControl variant="outlined">
                                    <InputLabel shrink htmlFor={`quality-input-${index}`}>
                                        Quality
                                    </InputLabel>
                                    <Select
                                        value={file.quality}
                                        variant="outlined"
                                        label="Quality"
                                        native
                                        inputProps={{
                                            id: `quality-input-${index}`,
                                        }}
                                        onChange={handleChangeQuality(index)}
                                        disabled={loading}
                                    >
                                        <option value="original">Original</option>
                                        <option value="high">High</option>
                                        <option value="medium">Medium</option>
                                        <option value="low">Low</option>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid size={{ xs: 4 }}>
                                <IconButton
                                    onClick={() => handleRemoveFile(index)}
                                    color="secondary"
                                    disabled={loading}
                                    size="large"
                                >
                                    <Delete />
                                </IconButton>
                            </Grid>
                        </>
                    )}

                    {file.status === 'WAIT' && <Schedule />}

                    {file.status === 'UPLOADING' && (
                        <Grid size={{ xs: 12 }}>
                            <CircularProgress />
                        </Grid>
                    )}

                    {file.status === 'FAIL' && <Error />}

                    {file.status === 'SUCCESS' && <Check />}
                </Grid>
            </Box>
        </ListItem>
    );
};

export default UploadFormFileRow;
